/** 与主应用「浏览器宽度较小」提示一致：window.innerWidth 小于该值视为窄屏 */
export const DRIVER_VIEWPORT_NARROW_WIDTH_PX = 1420;

/** 浏览器缩放约 ≥130% 时用于侧栏折叠（配合最大化窗口下的 screen/inner 比值启发式） */
export const DRIVER_VIEWPORT_ZOOM_COLLAPSE_RATIO = 1.27;

/** 判定窗口接近最大化的横向容差（px） */
export const DRIVER_VIEWPORT_MAXIMIZED_TOLERANCE_X_PX = 80;
